import { Component, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  standalone: false
})
export class IntroComponent {
  private translateService = inject(TranslateService);

  @Input() maxHeight: string;

  get textContent(): string {
    return this.translateService.instant('guided-tour.intro-text');
  }
}
